export const textDefaultProps = {
    tag: 'span',
    weight: 'regular',
    italic: false,
    color: '--color-neutral-130',
    display: 'block',
};
